export async function hashEmail(email = '') {
  if (typeof email !== 'string' || !email) {
    return;
  }
  const enc = new TextEncoder();
  const data = enc.encode(email.toLowerCase());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashString = Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
  return hashString;
}

export async function hashAndStoreEmail(email = '') {
  const hash = await hashEmail(email);
  if (hash) {
    sessionStorage.setItem('emailHash', hash);
  }
}

export function getHashedEmail() {
  return sessionStorage.getItem('emailHash');
}
